import { useSelector } from 'react-redux';
import ProductDisclaimers from '../ProductDisclaimers';

const ProductLegalNotices = () => {
  const taxDisclaimerMessageFooter = useSelector(
    s => s.dealerCustomer?.taxDisclaimerMessageFooter
  );
  const currentOrderId = useSelector(s => s.orders.current);
  const currentOrder = useSelector(s => s.orders.byId[currentOrderId] || {});
  const isQuantityMergeEnabled =
    currentOrder.orderExtendAttribute?.isQuantityMergeEnabled;
  return (
    <ProductDisclaimers
      isQuantityMergeEnabled={isQuantityMergeEnabled}
      taxDisclaimerMessageFooter={taxDisclaimerMessageFooter}
      className="py-3"
      disclaimerClassName="font-italic"
    />
  );
};

export default ProductLegalNotices;
